<template>
  <div class="home-info">
    <div class="about" :style="{ order: getVerticalData[0] }">
      <!-- <h2 class="tracking-in-contract">{{ aboutTitle }}</h2> -->

      <!-- MainNew -->
      <div v-for="(pic, index) in homePictures" :key="index" class="main-news">
        <div class="container">
          <img @contextmenu.prevent :src="cacheBuster(pic.path)" class="image" style="width:100%">
          <div class="middle">
            <h1 class="heading">{{ pic.title }}</h1>
            <p class="description">{{ pic.summary }}</p>
            <div v-if="isNews(pic.url)">
              <router-link :to="{ name: 'NewsDetail', params: { url: pic.url }}" v-if="!pic.hidden">
                <button class="read-more">{{ moreInfo }}</button>
              </router-link>
            </div>
            <div v-else>
              <router-link :to="pic.url" v-if="!pic.hidden">
                <button class="read-more">{{ moreInfo }}</button>
              </router-link>
            </div>
          </div>
        </div>

        <div style="height: 20px;"></div>
      </div>

    </div>
    <!-- new -->
    <div class="info-box" :style="{ order: getVerticalData[1] }">
      <div class="title">
        <h2>{{ newsTitle }}</h2>
        <img @contextmenu.prevent src="../../assets/title-line.png">
      </div>
      <div class="box" v-for="(inew, i) in topNews" :key="i">
        <p>{{ formatDate(inew.date || inew.createdAt) }}</p>
        <router-link :to="{ name: 'NewsDetail', params: { url: inew.url } }">{{ inew.title }}</router-link>
        <div class="box-content">
          <img @contextmenu.prevent :src="cacheBuster(inew.img)" @click.prevent="routeNewsDetail(inew.url)" id="news">
          <div class="summary">
            <div class="sum-text"><p>{{ inew.summary }}</p></div>
          </div>
        </div>
      </div>
      <div class="more">
        <router-link to="/news">{{ moreInfo }}</router-link>
      </div>
    </div>
    <!-- training service -->
    <div class="info-box" :style="{ order: getVerticalData[2] }">
      <div class="title">
        <h2>{{ trainingserviceTitle }}</h2>
        <img @contextmenu.prevent src="../../assets/title-line.png">
      </div>
      <div class="box" v-for="(inew, i) in topTrainingServices" :key="i">
        <p>{{ formatDate(inew.date || inew.createdAt) }}</p>
        <router-link :to="{ name: inew.routeName, params: { url: inew.url } }">{{ inew.name }}</router-link>
        <div class="box-content">
          <img @contextmenu.prevent :src="cacheBuster(inew.img)" @click.prevent="routeTSDetail(inew.routeName, inew.url)" id="news">
          <div class="summary">
            <div class="sum-text"><p>{{ inew.summary }}</p></div>
          </div>
        </div>
      </div>
      <div class="more">
        <router-link to="/training-services/pilot-training">{{ moreInfo }}</router-link>
      </div>
    </div>
    <!-- admissions -->
    <div class="info-box" :style="{ order: getVerticalData[3] }">
      <div class="title">
        <h2>{{ admissionTitle }}</h2>
        <img @contextmenu.prevent src="../../assets/title-line.png">
      </div>
      <div class="box" v-for="(inew, i) in topAdmissions" :key="i">
        <p>{{ formatDate(inew.createdAt) }}</p>
        <router-link :to="{ name: 'SPDetail', params: { url: inew.url } }">{{ inew.title }}</router-link>
        <div class="box-content">
          <img @contextmenu.prevent :src="cacheBuster(inew.img)" @click.prevent="routeAdmissionDetail(inew.url)" id="news">
          <div class="summary">
            <div class="sum-text"><p>{{ inew.summary }}</p></div>
          </div>
        </div>
      </div>
      <div class="more">
        <router-link to="/admissions/student-pilot">{{ moreInfo }}</router-link>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  mounted () {
    // Thêm sự kiện cuộn khi component được gắn vào DOM
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeUnmount () {
    // Xóa sự kiện khi component bị hủy
    window.removeEventListener('scroll', this.handleScroll)
  },
  computed: {
    getVerticalData () {
      return this.$store.getters['layout/getVerticalData']
    },
    homePictures () {
      return this.$store.getters['news/getHomeMainNews']
    },
    aboutTitle () {
      if (this.$store.state.lang === 'vn') return 'KIM CHỈ NAM CHO SỰ PHÁT TRIỂN'
      else return 'Guiding Principle For Development'
    },
    topNews () {
      return this.$store.getters['news/frontendHomeNews']
    },
    topTrainingServices () {
      return this.$store.getters['services/topTrainingServices']
    },
    topAdmissions () {
      return this.$store.getters['recruit/topAdmissions']
    },
    newsTitle () {
      if (this.$store.state.lang === 'vn') return 'tin tức mới nhất'
      else return 'latest news'
    },
    trainingserviceTitle () {
      if (this.$store.state.lang === 'vn') return 'dịch vụ huấn luyện'
      else return 'training services'
    },
    admissionTitle () {
      if (this.$store.state.lang === 'vn') return 'tuyển sinh'
      else return 'admissions'
    },
    moreInfo () {
      if (this.$store.state.lang === 'vn') return 'Xem thêm'
      else return 'Read more'
    }
  },
  methods: {
    routeNewsDetail (url) {
      this.$router.push({ name: 'NewsDetail', params: { url } })
    },
    routeTSDetail (route, url) {
      this.$router.push({ name: route, params: { url } })
    },
    routeAdmissionDetail (url) {
      this.$router.push({ name: 'SPDetail', params: { url } })
    },
    cacheBuster (url) {
      return `${url}?cacheBuster=${new Date().getTime()}`
    },
    formatDate (idate) {
      const date = new Date(idate)
      const day = String(date.getDate()).padStart(2, '0')
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const year = date.getFullYear()
      return `${day}/${month}/${year}`
    },
    isNews (url) {
      if (url.includes('/')) {
        return false
      } else return true
    }
  }
}
</script>
<style scoped>
.container {
  position: relative;
  width: 100%;

  background: linear-gradient(to top, rgba(35, 37, 39, 1), rgba(68, 212, 212, 0));
  overflow: hidden;
  /* Thêm thuộc tính này để giới hạn vùng hiển thị */

}

.image {
  opacity: 1;
  display: block;
  width: 100%;
  height: 100%;
  transition: .5s ease;
  backface-visibility: hidden;
  object-fit: cover;
}

.middle {
  transition: .5s ease;
  opacity: 0;
  position: absolute;
  bottom: 20px;
  /* Đặt ở phía dưới */
  left: 10px;
  /* Đặt ở góc trái */
  text-align: left;
  color: white;
  /* Căn chữ sang trái nếu cần */
}

.container:hover .image {
  transform: scale(1.1);
  mask-image: linear-gradient(to top, rgba(0, 0, 0, 0), rgba(0, 0, 0, 1));
  /* opacity: 0.1; */
}

.container:hover .middle {
  opacity: 1;
}

.text {
  background-color: #04AA6D;
  color: white;
  font-size: 16px;
  padding: 16px 32px;
}

.heading {
  font-size: 24px;
  margin: 0;
  font-weight: bold;
}

.description {
  font-size: 14px;
  margin: 10px 0;
}

.read-more {
  background-color: white;
  color: #333;
  border: none;
  padding: 8px 16px;
  cursor: pointer;
  font-size: 14px;
}

.read-more:hover {
  background-color: #ddd;
}

.tracking-in-contract {
  -webkit-animation: tracking-in-contract 0.8s cubic-bezier(0.215, 0.610, 0.355, 1.000) both;
  animation: tracking-in-contract 0.8s cubic-bezier(0.215, 0.610, 0.355, 1.000) both;
  opacity: 1;
  /* Hiển thị phần tử khi thêm lớp */
  transition: opacity 0.8s ease;
  /* Để thêm hiệu ứng mềm mại khi hiện */
}

/* Keyframes cho hiệu ứng */
@-webkit-keyframes tracking-in-contract {
  0% {
    letter-spacing: 1em;
    opacity: 0;
  }

  40% {
    opacity: 0.6;
  }

  100% {
    letter-spacing: normal;
    opacity: 1;
  }
}

@keyframes tracking-in-contract {
  0% {
    letter-spacing: 1em;
    opacity: 0;
  }

  40% {
    opacity: 0.6;
  }

  100% {
    letter-spacing: normal;
    opacity: 1;
  }
}

.home-info {
  display: flex;
  flex-direction: column;
}

.home-info .about {
  background: url(../../assets/new-image/bg-home.png);
  padding: 20px 40px;
  margin-bottom: 30px;
}

.about h2 {
  color: #006884;
  text-align: center;
  margin: 10px 0px;
  font-weight: 700;
  font-size: 30px;
}

.about img {
  max-width: 100%;
  /* margin: 20px 0px; */
}

.main-news img {
  width: 100%;
  object-fit: cover;
}

.info-box {
  margin-bottom: 30px;
}

.title {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.title h2 {
  text-transform: uppercase;
  font-weight: 700;
  color: #006884;
  margin-right: 10px;
  font-size: 28px;
}

.box {
  margin-top: 10px;
  padding-bottom: 15px;
  /* border-bottom: 1px dashed black; */
}

.box a {
  font-size: 22px;
  color: #006884;
  text-decoration: none;
  font-weight: 700;
}

.box-content {
  margin-top: 5px;
  display: flex;
}

.box-content img {
  width: 180px;
  height: 120px;
  margin-right: 12px;
  flex-shrink: 0;
  border: 1px solid #d9d9d9;
  cursor: pointer;
  border-radius: 10px;
  object-fit: cover;
}

.more {
  margin-top: 15px;
  display: flex;
  justify-content: flex-end;
}

.more a {
  color: #3881EE;
  font-size: 15px;
  text-decoration: none;
  text-transform: none;
  font-weight: 700;
}

.summary {
  height: 120px;
}

.sum-text {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
}

@media (max-width: 720px) {
  .title h2 {
    font-size: 22px;
  }

  .title img {
    width: 192px;
  }

  .box a {
    font-size: 18px;
  }

  .box p {
    font-size: 14px;
  }

  .sum-text {
    -webkit-line-clamp: 6;
  }

  .more a {
    font-size: 14px;
  }
}

@media (max-width: 485px) {
  .title img {
    display: none;
  }

  .box-content img {
    width: 120px;
    height: 100px;
  }

  .box p {
    font-size: 12px;
  }

  .summary {
    height: 100px;
  }
}
</style>
